import { useState } from "react";
import { X } from "lucide-react";

const KEY = "mp-announce-closed-2026-09-18";
// Εμφάνιση μέχρι και 18/9/2026, ώρα Ελλάδας (UTC+3).
const UNTIL = Date.parse("2026-09-18T23:59:59+03:00");
const MESSAGE = "Το κατάστημα θα παραμείνει κλειστό την Παρασκευή 18/9, 18:00–20:00";

/**
 * Λεπτή, παιχνιδιάρικη μπάρα ανακοίνωσης στο πάνω μέρος της οθόνης.
 * Κλείνει οριστικά ανά χρήστη (localStorage) και λήγει αυτόματα.
 */
export function AnnouncementBar() {
  // Αποδίδεται και στον server (χωρίς localStorage) ώστε ο χώρος της μπάρας να
  // υπάρχει από το πρώτο HTML — αλλιώς η εμφάνισή της μετά το hydration
  // μετατόπιζε όλη τη σελίδα (CLS). Αν ο χρήστης την έχει κλείσει, ένα inline
  // script στο <html> προσθέτει την κλάση `mp-announce-hidden` πριν την πρώτη
  // ζωγραφική και το CSS την κρύβει χωρίς μετατόπιση.
  const [closed, setClosed] = useState(false);

  if (closed || Date.now() > UNTIL) return null;

  const close = () => {
    try {
      window.localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    const root = document.documentElement;
    root.classList.add("mp-announce-hidden");
    root.classList.remove("has-announce");
    setClosed(true);
  };

  return (
    <>
      {/* Κρατάει χώρο ώστε να μην καλύπτεται το header από τη σταθερή μπάρα */}
      <div aria-hidden className="mp-announce px-10 py-2 text-xs sm:text-sm">
        <span className="invisible">{MESSAGE}</span>
      </div>
      <div
        role="status"
        className="mp-announce fixed inset-x-0 top-0 z-[70] flex min-h-[34px] items-center justify-center gap-2 overflow-hidden border-b border-primary/30 bg-accent px-10 py-2 text-center text-xs font-extrabold text-accent-foreground shadow-md sm:text-sm"
      >
        <span className="animate-bob text-base" aria-hidden>🐼</span>
        <span>{MESSAGE}</span>
        <span className="hidden animate-bob text-base sm:inline" aria-hidden>🔔</span>
        <button
          type="button"
          onClick={close}
          aria-label="Κλείσιμο ανακοίνωσης"
          className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-accent-foreground transition hover:bg-background/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </>
  );
}